export const selectEmployeeBalances = (state) =>
  state.leaveAdjustmentReimbursement?.employeeBalances || [];

export const selectAdjustmentHistory = (state) =>
  state.leaveAdjustmentReimbursement?.adjustmentHistory || [];

export const selectLoadingBalances = (state) =>
  state.leaveAdjustmentReimbursement?.loadingBalances || false;

export const selectLoadingHistory = (state) =>
  state.leaveAdjustmentReimbursement?.loadingHistory || false;

export const selectAdjusting = (state) =>
  state.leaveAdjustmentReimbursement?.adjusting || false;

export const selectAdjustmentError = (state) =>
  state.leaveAdjustmentReimbursement?.error || null;
